const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class LookCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    const disableMobile = this.dataset.layoutMobile === 'twoColumn'

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.7,
          spacing: 1,
        },
        breakpoints: {
          '(max-width: 767px)': {
            disabled: disableMobile,
          },
          '(min-width: 768px)': {
            disabled: false,
            slides: {
              perView: 3,
              spacing: 1,
            },
          },
          '(min-width: 901px)': {
            disabled: false,
            slides: {
              perView: 4,
              spacing: 1,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('look-carousel')) {
  customElements.define('look-carousel', LookCarousel)
}
